<template>
  <div class="content">
    <div class="part1">
      <div ref="header" :style="{ 'margin': 'auto',
        'height': isShowSearch== 1 ?'130px':'65px',
        'font-size': '14px',
        'line-height': '65px',
        'display': 'flex',
        'justify-content': 'space-around'}" 
        :class="{ whiteHeader: topOffect > 50 }">
        <!-- 清耳话声的LOGO，点击可跳转至首页 -->
        <div class="logoBox" @click="goHome()">
          <a class="logo" href="javaScript:;">
            <img style="object-fit:cover;height: 100%" src="@/assets/image/logo_new.png"></img>
          </a>
        </div>
        <!--  -->
        <div force-render>
          <!-- 默认展示首页，企业新闻组件在离开时会被自动销毁，不进行缓存 -->
          <el-tabs v-model="activeName1" @tab-click="clickTab" :exclude="noCacheTabs">
            <!-- label中为标签显示的内容 -->
            <el-tab-pane label="首页" name="1"></el-tab-pane>
            <el-tab-pane label="专业技术" name="2"></el-tab-pane>
            <el-tab-pane label="产品中心" name="3"></el-tab-pane>
            <el-tab-pane label="用户中心" name="4"></el-tab-pane>
            <el-tab-pane label="企业新闻"  name="5"></el-tab-pane>
            <el-tab-pane label="名家新作" name="6"></el-tab-pane>
            <el-tab-pane label="听觉名医录" name="7"></el-tab-pane>
            <el-tab-pane label="关于我们" name="8"></el-tab-pane>
            <!-- <el-tab-pane label="下载中心" name="9"></el-tab-pane> -->
          </el-tabs>
          <!-- 搜索框和搜索按钮 -->
          <div style="text-align: center;line-height: 0px;display:flex" v-if="isShowSearch">
            <el-input  prefix-icon='el-icon-search' v-model="search_text">
              <template slot="append"> 
                <el-button @click="goArticle()" >搜索</el-button>
              </template>
            </el-input>
          </div>
        </div>
        <div style="display:flex; line-height: 65px; height: 65px;">
          <div class="measuBtn" >
            <van-button v-if="isShowSearch" 
              icon="http://admin.qingerhuasheng.com/search/close.png"  
              @click="closeSearch"  
              style="background: transparent;border: 0px;">
            </van-button>
            <!-- 点击显示主观量表 -->
            <van-button  @click="dialogTableVisible=true" 
              icon="http://admin.qingerhuasheng.com/search/table.png" 
              size="small" round color="#733d9a" style="height: 30px">
              耳鸣测评
            </van-button>
          </div>
          <!-- 登录注册，在仓库里没有用户信息或用户手机号信息的时候展示 -->
          <div v-if="$store.state.customer.customerInfo.mobile == ''">
            <a  href="javascript:;" @click="goLogin(2)"  style="color: black">注册</a> |
            <a  href="javaScript:;" @click="goLogin(1)" style="color: black">登录</a>
          </div>
          <!-- 当用户手机号码存在且不是undefined时，显示用户的姓名和手机号码，点击跳转至用户个人中心 -->
          <div v-if="$store.state.customer.customerInfo.mobile != ''">
            <a href="javaScript:;" style="color: black" @click="goUserInfo">
              {{ $store.state.customer.customerInfo.customerName }}  {{ getMobile($store.state.customer.customerInfo.mobile) }}
            </a>
            <!-- 退出登录 -->
            <a href="javaScript:;" style="color:#803288" @click="outLogin()">退出</a>
          </div>
      </div>
      </div>
    </div>
    <el-dialog title="选择量表" :visible.sync="dialogTableVisible" width="40%" >
      <div>
        <van-cell is-link @click="goMeasure(2)">
          <template>
            <span class="custom-title">耳鸣功能指数量表（TFI）</span>
          </template>
        </van-cell>
        <van-cell is-link @click="goMeasure(1)">
          <template>
            <span class="custom-title">耳鸣致残量表（THI）</span>
          </template>
        </van-cell>
        <van-cell is-link @click="goMeasure(4)">
          <template>
            <span class="custom-title">耳鸣声响和烦躁程度量表（VAS）</span>
          </template>
        </van-cell>
        <van-cell is-link @click="goMeasure(3)">
          <template>
            <span class="custom-title">耳鸣评价量表（TEQ）</span>
          </template>
        </van-cell>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import deviceAdapter from '@/mixins/deviceAdapter'
import navigationFixed from '@/mixins/navigationFixed'
import { getMobile } from '@/utils/util'
export default {
  name:'Header',
  mixins: [deviceAdapter, navigationFixed],
  props: {
    activeName: {
      type: String,
      default: '1'
    }
  },
  data() {
    return {
      noCacheTabs: ['7'],         // 7号组件在离开时会被销毁，不进行缓存
      activeName1:'1',            // 展示的页面的名字
      dialogTableVisible:false,   // 主观量表的显示，默认不显示
      search_text:'',             // 搜索框中输入的内容
      isShowSearch:0              // 是否展示搜索框，默认不展示
    };
  },
  methods: {
    getMobile,
    changeAc(num){
      this.activeName1 = num;
    },
    // 点击头部导航栏
    handleClick(tab, event){
      this.$router.push({name:tab.name});
    },
    // 显示搜索框
    openSearch(){
      this.isShowSearch = 1
    },
    // 搜索，跳转至相应的界面
    goArticle(){
      this.$router.push({ name:  "articles", params: { search_text: this.search_text } })
    },
    // 关闭搜索框和搜索按钮的显示
    closeSearch(){
      this.isShowSearch = 0
    },
    // 登录或注册，id为1表示登录，id为2表示注册
    goLogin(id) {
      this.$router.push({ name: "login", params: { is_login: id + "" } })
    },
    // 跳转至首页
    goHome(){
      this.$router.push({ name: "Home" })
    },
    // 跳转至用户个人中心界面
    goUserInfo() {
      this.$router.push({ name: "userInfo",query:{tab:3} })
    },
    // 退出登录
    outLogin() {
      this.$store.dispatch("outLogin");
      this.$router.push({ name: "Home" })
    },
    // 跳转至相应的量表
    goMeasure(category){
      // category为量表标号，即跳转至哪个量表
      this.dialogTableVisible =false;
      if(!this.$store.state.customer.customerInfo.mobile){
        // 若该用户未登录，则跳转至登录界面
        this.$router.push({name: 'login' ,params:{'scene':4,category:category}})
      }else{
        // 若该用户已登录，则跳转至相应的量表界面
        this.$router.replace({ name: "pcMeasurement",query:{
          scene:1,
          category:category
        }})
      }
    }
  },
};
</script>

<style scoped>
.main {
  margin: 0;
  padding: 0;
}
.part1 {
  width: 100%;
  /* 图片可以保有其原有的尺寸，或者拉伸到新的尺寸，或者在保持其原有比例的同时缩放到元素的可用空间的尺寸。 */
  background-size: 100% 100%;
  position: relative;
}
.header {
  margin: auto;
  height: 130px;
  font-size: 14px;
  line-height: 65px;
  display: flex;
  justify-content: space-around;
}
.whiteHeader {
  background: rgba(255, 255, 255, 0.9);
  position: fixed;
  min-width: 1400px;
  width: 100%;
  z-index: 20;
  top: 0;
}
.logo {
  align-items: center;
  height: 45px;
  margin-right: 10px;
}
.logoBox {
  display: flex;
  line-height: 65px;
  height: 65px;
  align-items: center;
  font-size: 18px;
}
.measuBtn {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
::v-deep .el-tabs__item {
  padding-bottom: 1%;
  font-weight:bold;
}
::v-deep .el-tabs__nav {
  padding-bottom: 0.5%;
}
::v-deep .el-tabs__item.is-active {
  color: #9d439f;
}
::v-deep .el-tabs__item:hover {
  color: #9d439f;
}
::v-deep .el-tabs__active-bar {
  background-color: #9d439f;
}
::v-deep .el-tabs__nav {
  height: 50px !important;
}
/*去掉tabs底部的下划线*/
::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}
.el-menu-item {
  padding-bottom: 1%;
  font-weight: bold;
  /* border-bottom: none;
  text-decoration: none; */
}
.el-menu-item:hover {
  color: #9d439f;
}
.el-menu-item.is-active {
  color: #9d439f;
  border-bottom-color: #9d439f;
}
</style>